function set(key: string, value?: object): void {
  if (value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  } else {
    sessionStorage.removeItem(key)
  }
}

function get(key: string): any {
  return JSON.parse(sessionStorage.getItem(key) ?? '{}')
}

export const CacheAdapter = {
  set,
  get,
}
